import { render, staticRenderFns } from "./TheNoteForm.vue?vue&type=template&id=0dd97b3a&scoped=true"
import script from "./TheNoteForm.vue?vue&type=script&lang=js"
export * from "./TheNoteForm.vue?vue&type=script&lang=js"
import style0 from "./TheNoteForm.vue?vue&type=style&index=0&id=0dd97b3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd97b3a",
  null
  
)

export default component.exports